/**
 * FreeQurans Verification System
 * Handles SMS/Email verification before checkout
 * Includes Muslim name detection flow
 */

(function () {
    'use strict';

    const API_BASE = 'https://api.freequrans.co.uk';
    const RESEND_COOLDOWN = 60;

    let currentFirstName = '';
    let currentLastName = '';
    let currentEmail = '';
    let currentPhone = '';
    let resendTimer = null;
    let resendCountdown = RESEND_COOLDOWN;
    let isVerifying = false;
    let identityFlaggedMuslim = false;

    let popup;
    let dialog;
    let closeBtn;

    let step0;
    let stepMuslim;
    let step1;
    let stepAgeInfo;
    let step2;
    let step3;
    let stepBlocked;

    let firstNameInput;
    let lastNameInput;
    let emailInput;
    let phoneInput;
    let countryCodeInput;

    let countrySelector;
    let countryDropdown;
    let selectedFlag;
    let selectedCode;

    let identityForm;
    let sendForm;
    let checkForm;

    let identityBtn;
    let sendBtn;
    let verifyBtn;
    let resendBtn;
    let backBtn;
    let backToIdentityBtn;
    let proceedAnywayBtn;

    let identityError;
    let sendError;
    let checkError;

    let otpInputs;
    let sentToEl;
    let resendTimerEl;

    let blockedCloseBtn;
    let phoneHintEl;
    let nonMuslimConfirm;
    let nonMuslimConfirmRow;
    let ageConfirm;
    let ageConfirmRow;
    let ageWhyBtn;
    let ageInfoBackBtn;
    let whatsappConsent;

    let lastFocusedElement = null;
    let focusRafId = null;
    let currentStepKey = null;

    const STEP_META = {
        0: { title: 'fq-step0-title', desc: 'fq-step0-desc', focusId: 'fq-firstname-input' },
        muslim: { title: 'fq-step-muslim-title', desc: 'fq-step-muslim-desc', focusId: 'fq-proceed-anyway-btn' },
        1: { title: 'fq-step1-title', desc: 'fq-step1-desc', focusId: 'fq-phone-input' },
        'age-info': { title: 'fq-step-age-title', desc: 'fq-step-age-desc', focusId: 'fq-age-info-back-btn' },
        2: { title: 'fq-step2-title', desc: 'fq-step2-desc', focusId: 'fq-verify-code-btn' },
        3: { title: 'fq-step3-title', desc: 'fq-step3-desc', focusId: 'fq-verify-step-3' },
        4: { title: 'fq-step-blocked-title', desc: 'fq-step-blocked-desc', focusId: 'fq-blocked-close-btn' }
    };

    function isMobileViewport() {
        return window.matchMedia('(max-width: 749px)').matches;
    }

    function isTextInputElement(el) {
        if (!el || !(el instanceof HTMLElement)) return false;
        const tag = el.tagName.toLowerCase();
        return tag === 'input' || tag === 'textarea' || tag === 'select';
    }

    function init() {
        popup = document.getElementById('fq-verify-popup');
        if (!popup) return;

        dialog = document.getElementById('fq-verify-dialog');
        closeBtn = document.getElementById('fq-verify-close');

        step0 = document.getElementById('fq-verify-step-0');
        stepMuslim = document.getElementById('fq-verify-step-muslim');
        step1 = document.getElementById('fq-verify-step-1');
        stepAgeInfo = document.getElementById('fq-verify-step-age-info');
        step2 = document.getElementById('fq-verify-step-2');
        step3 = document.getElementById('fq-verify-step-3');
        stepBlocked = document.getElementById('fq-verify-step-blocked');

        firstNameInput = document.getElementById('fq-firstname-input');
        lastNameInput = document.getElementById('fq-lastname-input');
        emailInput = document.getElementById('fq-email-input');

        identityForm = document.getElementById('fq-verify-form-identity');
        identityBtn = document.getElementById('fq-identity-btn');
        identityError = document.getElementById('fq-identity-error');

        proceedAnywayBtn = document.getElementById('fq-proceed-anyway-btn');

        phoneInput = document.getElementById('fq-phone-input');
        countryCodeInput = document.getElementById('fq-country-code');
        countrySelector = document.getElementById('fq-country-selector');
        countryDropdown = document.getElementById('fq-country-dropdown');
        selectedFlag = document.getElementById('fq-selected-flag');
        selectedCode = document.getElementById('fq-selected-code');
        phoneHintEl = document.getElementById('fq-phone-hint');

        sendForm = document.getElementById('fq-verify-form-send');
        sendBtn = document.getElementById('fq-send-code-btn');
        sendError = document.getElementById('fq-send-error');
        backToIdentityBtn = document.getElementById('fq-back-to-identity-btn');

        nonMuslimConfirm = document.getElementById('fq-non-muslim-confirm');
        nonMuslimConfirmRow = document.getElementById('fq-non-muslim-confirm-row');
        ageConfirm = document.getElementById('fq-age-confirm');
        ageConfirmRow = document.getElementById('fq-age-confirm-row');
        ageWhyBtn = document.getElementById('fq-age-why-btn');
        ageInfoBackBtn = document.getElementById('fq-age-info-back-btn');
        whatsappConsent = document.getElementById('fq-whatsapp-consent');

        checkForm = document.getElementById('fq-verify-form-check');
        verifyBtn = document.getElementById('fq-verify-code-btn');
        resendBtn = document.getElementById('fq-resend-btn');
        backBtn = document.getElementById('fq-back-btn');
        checkError = document.getElementById('fq-check-error');

        otpInputs = document.querySelectorAll('.fq-verify-otp-input');
        sentToEl = document.getElementById('fq-sent-to');
        resendTimerEl = document.getElementById('fq-resend-timer');

        blockedCloseBtn = document.getElementById('fq-blocked-close-btn');

        bindEvents();
    }

    function bindEvents() {
        if (closeBtn) {
            closeBtn.addEventListener('click', closePopup);
        }

        if (blockedCloseBtn) {
            blockedCloseBtn.addEventListener('click', closePopup);
        }

        popup.addEventListener('click', function (e) {
            if (e.target === popup) closePopup();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
                closePopup();
            }
        });

        if (dialog) {
            dialog.addEventListener('keydown', handleDialogKeydown);
        }

        if (identityForm) {
            identityForm.addEventListener('submit', handleIdentitySubmit);
        }

        if (proceedAnywayBtn) {
            proceedAnywayBtn.addEventListener('click', function () {
                showStep(1);
            });
        }

        if (sendForm) {
            sendForm.addEventListener('submit', handleSendCode);
        }

        if (backToIdentityBtn) {
            backToIdentityBtn.addEventListener('click', function () {
                showStep(0);
            });
        }

        if (nonMuslimConfirm) {
            nonMuslimConfirm.addEventListener('change', function () {
                if (nonMuslimConfirmRow) nonMuslimConfirmRow.classList.remove('is-invalid');
                syncConfirmCheckboxesUi();
            });
        }

        if (ageConfirm) {
            ageConfirm.addEventListener('change', function () {
                if (ageConfirmRow) ageConfirmRow.classList.remove('is-invalid');
                syncConfirmCheckboxesUi();
            });
        }

        if (ageWhyBtn) {
            ageWhyBtn.addEventListener('click', function (e) {
                e.preventDefault();
                showStep('age-info');
            });
        }

        if (ageInfoBackBtn) {
            ageInfoBackBtn.addEventListener('click', function () {
                showStep(1);
            });
        }

        if (checkForm) {
            checkForm.addEventListener('submit', handleVerifyCode);
        }

        otpInputs.forEach(function (input, index) {
            input.addEventListener('input', function (e) {
                const val = e.target.value.replace(/\D/g, '');

                if (val.length > 1) {
                    const digits = val.split('').slice(0, otpInputs.length);
                    digits.forEach(function (digit, i) {
                        if (otpInputs[i]) otpInputs[i].value = digit;
                    });

                    if (!isMobileViewport()) {
                        const nextIndex = digits.length < otpInputs.length ? digits.length : otpInputs.length - 1;
                        otpInputs[nextIndex].focus();
                    }

                    if (digits.length === 6) {
                        handleVerifyCode(new Event('submit'));
                    }
                } else {
                    e.target.value = val;
                    if (!isMobileViewport() && val && index < otpInputs.length - 1) {
                        otpInputs[index + 1].focus();
                    }
                }

                if (getOtpCode().length === 6) {
                    handleVerifyCode(new Event('submit'));
                }
            });

            input.addEventListener('keydown', function (e) {
                if (!isMobileViewport() && e.key === 'Backspace' && !e.target.value && index > 0) {
                    otpInputs[index - 1].focus();
                }
            });

            input.addEventListener('paste', function (e) {
                e.preventDefault();
                const paste = (e.clipboardData || window.clipboardData).getData('text');
                const digits = paste.replace(/\D/g, '').slice(0, 6);

                digits.split('').forEach(function (digit, i) {
                    if (otpInputs[i]) otpInputs[i].value = digit;
                });

                if (digits.length === 6) {
                    handleVerifyCode(new Event('submit'));
                }
            });
        });

        if (resendBtn) {
            resendBtn.addEventListener('click', handleResendCode);
        }

        if (backBtn) {
            backBtn.addEventListener('click', function () {
                showStep(1);
            });
        }

        if (phoneInput) {
            phoneInput.addEventListener('input', function (e) {
                e.target.value = e.target.value.replace(/\D/g, '');
            });
        }

        if (countrySelector && countryDropdown) {
            countrySelector.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                toggleCountryDropdown();
            });

            const countryOptions = countryDropdown.querySelectorAll('.fq-country-option');
            countryOptions.forEach(function (option) {
                option.addEventListener('click', function (e) {
                    e.preventDefault();
                    selectCountry(option.dataset.code, option.dataset.flag, option.dataset.country);
                });
            });

            document.addEventListener('click', function (e) {
                const target = e.target;
                if (!countrySelector.contains(target) && !countryDropdown.contains(target)) {
                    closeCountryDropdown();
                }
            });
        }

        syncConfirmCheckboxesUi();
        syncPhoneCountryUi();
        hideAllSteps();
        setStepVisibility(step0, true);
        syncDialogHeading(0);
    }

    function getStepElement(stepKey) {
        if (stepKey === 0) return step0;
        if (stepKey === 'muslim') return stepMuslim;
        if (stepKey === 1) return step1;
        if (stepKey === 'age-info') return stepAgeInfo;
        if (stepKey === 2) return step2;
        if (stepKey === 3) return step3;
        if (stepKey === 4) return stepBlocked;
        return null;
    }

    function hideAllSteps() {
        [step0, stepMuslim, step1, stepAgeInfo, step2, step3, stepBlocked].forEach(function (step) {
            setStepVisibility(step, false);
        });
    }

    function setStepVisibility(stepElement, visible) {
        if (!stepElement) return;
        stepElement.hidden = !visible;
        stepElement.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function syncDialogHeading(stepKey) {
        if (!dialog) return;

        const meta = STEP_META[stepKey];
        if (!meta) return;

        dialog.setAttribute('aria-labelledby', meta.title);
        dialog.setAttribute('aria-describedby', meta.desc);
    }

    function focusStep(stepKey) {
        const meta = STEP_META[stepKey];
        if (!meta) return;

        const target = document.getElementById(meta.focusId);
        if (!target) return;

        if (focusRafId) {
            cancelAnimationFrame(focusRafId);
            focusRafId = null;
        }

        // Avoid auto-focusing form inputs on mobile to prevent keyboard jank and accidental text selection.
        if (isMobileViewport() && (isTextInputElement(target) || stepKey === 2)) {
            return;
        }

        focusRafId = requestAnimationFrame(function () {
            focusRafId = null;
            if (stepKey === 2 && otpInputs[0]) {
                otpInputs[0].focus({ preventScroll: true });
            } else if (target === step3 || target === stepBlocked) {
                if (dialog) dialog.focus({ preventScroll: true });
            } else {
                target.focus({ preventScroll: true });
            }
        });
    }

    function handleDialogKeydown(e) {
        if (e.key !== 'Tab' || !popup.classList.contains('is-visible')) return;

        const focusable = getFocusableElements();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (e.shiftKey && active === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && active === last) {
            e.preventDefault();
            first.focus();
        }
    }

    function getFocusableElements() {
        if (!dialog) return [];

        return Array.from(
            dialog.querySelectorAll(
                'button:not([disabled]):not([hidden]), a[href]:not([hidden]), input:not([disabled]):not([hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
        ).filter(function (el) {
            return el.offsetParent !== null || el === document.activeElement;
        });
    }

    function toggleCountryDropdown() {
        if (!countryDropdown) return;
        const isOpen = countryDropdown.classList.contains('is-open');
        if (isOpen) closeCountryDropdown();
        else openCountryDropdown();
    }

    function openCountryDropdown() {
        if (!countryDropdown || !countrySelector) return;

        countryDropdown.hidden = false;
        requestAnimationFrame(function () {
            countryDropdown.classList.add('is-open');
        });
        countrySelector.setAttribute('aria-expanded', 'true');
    }

    function closeCountryDropdown() {
        if (!countryDropdown || !countrySelector) return;

        countryDropdown.classList.remove('is-open');
        countryDropdown.hidden = true;
        countrySelector.setAttribute('aria-expanded', 'false');
    }

    function selectCountry(code, flag) {
        if (!code || !flag || !countryCodeInput || !selectedFlag || !selectedCode) return;

        countryCodeInput.value = code;
        selectedFlag.textContent = flag;
        selectedCode.textContent = code;

        const options = countryDropdown ? countryDropdown.querySelectorAll('.fq-country-option') : [];
        options.forEach(function (opt) {
            opt.setAttribute('aria-selected', opt.dataset.code === code ? 'true' : 'false');
        });

        closeCountryDropdown();
        syncPhoneCountryUi();
        if (phoneInput && !isMobileViewport()) phoneInput.focus();
    }

    function syncPhoneCountryUi() {
        if (!phoneInput || !countryCodeInput) return;

        const code = countryCodeInput.value;

        if (code === '+44') {
            phoneInput.placeholder = '07123 456789';
            if (phoneHintEl) {
                phoneHintEl.textContent = 'We will send a 6-digit code to verify your number (UK).';
            }
        } else if (code === '+1') {
            phoneInput.placeholder = '201 555 0123';
            if (phoneHintEl) {
                phoneHintEl.textContent = 'We will send a 6-digit code to verify your number (US).';
            }
        } else if (phoneHintEl) {
            phoneHintEl.textContent = 'We will send a 6-digit code to verify your number.';
        }
    }

    function syncConfirmCheckboxesUi() {
        if (!sendBtn) return;
        if (sendBtn.dataset && sendBtn.dataset.fqLoading === 'true') return;

        const nonMuslimConfirmed = nonMuslimConfirm ? nonMuslimConfirm.checked : true;
        const ageConfirmed = ageConfirm ? ageConfirm.checked : true;

        sendBtn.disabled = !(nonMuslimConfirmed && ageConfirmed);
    }

    function ensureConfirmationsChecked() {
        let valid = true;

        if (nonMuslimConfirm && !nonMuslimConfirm.checked) {
            if (nonMuslimConfirmRow) nonMuslimConfirmRow.classList.add('is-invalid');
            showError('send', 'Please confirm that you are not a Muslim to continue.');
            nonMuslimConfirm.focus();
            valid = false;
        }

        if (ageConfirm && !ageConfirm.checked && valid) {
            if (ageConfirmRow) ageConfirmRow.classList.add('is-invalid');
            showError('send', 'Please confirm that you are over 18 to continue.');
            ageConfirm.focus();
            valid = false;
        }

        return valid;
    }

    function openPopup() {
        if (!popup || !dialog) return;

        lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        resetForm();
        showStep(0);
    }

    function closePopup() {
        if (!popup) return;

        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        clearResendTimer();
        closeCountryDropdown();

        if (focusRafId) {
            cancelAnimationFrame(focusRafId);
            focusRafId = null;
        }

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus({ preventScroll: true });
        }
    }

    function showStep(stepKey) {
        const targetStep = getStepElement(stepKey);
        if (!targetStep) return;

        if (currentStepKey === stepKey && targetStep.hidden === false) {
            return;
        }

        hideAllSteps();
        setStepVisibility(targetStep, true);
        syncDialogHeading(stepKey);
        currentStepKey = stepKey;

        if (stepKey === 1) {
            syncConfirmCheckboxesUi();
        }

        if (stepKey === 2) {
            startResendTimer();
        }

        if (stepKey !== 2) {
            clearResendTimer();
        }

        closeCountryDropdown();
        focusStep(stepKey);
    }

    function resetForm() {
        currentStepKey = null;
        identityFlaggedMuslim = false;

        if (firstNameInput) firstNameInput.value = '';
        if (lastNameInput) lastNameInput.value = '';
        if (emailInput) emailInput.value = '';
        if (phoneInput) phoneInput.value = '';

        if (nonMuslimConfirm) nonMuslimConfirm.checked = false;
        if (ageConfirm) ageConfirm.checked = false;
        if (whatsappConsent) whatsappConsent.checked = true;

        if (nonMuslimConfirmRow) nonMuslimConfirmRow.classList.remove('is-invalid');
        if (ageConfirmRow) ageConfirmRow.classList.remove('is-invalid');

        otpInputs.forEach(function (input) {
            input.value = '';
        });

        clearError('identity');
        clearError('send');
        clearError('check');

        if (identityBtn) setButtonLoading(identityBtn, false);
        if (sendBtn) setButtonLoading(sendBtn, false);
        if (verifyBtn) setButtonLoading(verifyBtn, false);

        if (resendBtn) resendBtn.hidden = true;
        if (resendTimerEl) resendTimerEl.hidden = false;

        syncConfirmCheckboxesUi();
        syncPhoneCountryUi();
    }

    function getFullPhone() {
        const code = countryCodeInput.value;
        let number = phoneInput.value.replace(/\D/g, '');

        if (code === '+44') {
            if (number.startsWith('44')) {
                number = number.substring(2);
            }
            if (number.startsWith('0')) {
                number = number.substring(1);
            }
        } else if (code === '+1') {
            if (number.length === 11 && number.startsWith('1')) {
                number = number.substring(1);
            }
        }

        return code + number;
    }

    function getOtpCode() {
        return Array.from(otpInputs).map(function (input) {
            return input.value;
        }).join('');
    }

    async function handleIdentitySubmit(e) {
        e.preventDefault();
        clearError('identity');

        const firstName = firstNameInput.value.trim();
        const lastName = lastNameInput.value.trim();
        const email = emailInput.value.trim();

        if (!firstName) {
            showError('identity', 'Please enter your first name.');
            firstNameInput.focus();
            return;
        }

        if (!lastName) {
            showError('identity', 'Please enter your last name.');
            lastNameInput.focus();
            return;
        }

        if (!isValidEmail(email)) {
            showError('identity', 'Please enter a valid email address.');
            emailInput.focus();
            return;
        }

        currentFirstName = firstName;
        currentLastName = lastName;
        currentEmail = email;

        setButtonLoading(identityBtn, true);

        try {
            const response = await fetch(API_BASE + '/api/verify/check-identity', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    firstName: firstName,
                    lastName: lastName,
                    email: email
                })
            });

            const data = await response.json();

            if (data.success && data.likelyMuslim === true) {
                console.log('[FQ] Muslim name detected:', data.reason);
                identityFlaggedMuslim = true;
                showStep('muslim');
            } else {
                identityFlaggedMuslim = false;
                showStep(1);
            }
        } catch (error) {
            console.log('[FQ] Identity check failed, proceeding:', error.message);
            showStep(1);
        } finally {
            setButtonLoading(identityBtn, false);
        }
    }

    async function handleSendCode(e) {
        e.preventDefault();
        clearError('send');

        if (!ensureConfirmationsChecked()) {
            return;
        }

        const code = countryCodeInput.value;
        currentPhone = getFullPhone();

        const cleanedDigits = currentPhone.replace(/\D/g, '');
        const minDigits = code === '+44' ? 11 : 11;
        const maxDigits = 13;

        if (cleanedDigits.length < minDigits || cleanedDigits.length > maxDigits) {
            showError('send', code === '+44' ? 'Please enter a valid UK mobile number.' : 'Please enter a valid US phone number.');
            phoneInput.focus();
            return;
        }

        setButtonLoading(sendBtn, true);

        try {
            const response = await fetch(API_BASE + '/api/verify/send', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    contact: currentPhone,
                    channel: 'sms',
                    countryCode: code === '+44' ? 'GB' : 'US'
                })
            });

            const data = await response.json();

            if (response.status === 403) {
                showStep(4);
                return;
            }

            if (!response.ok) {
                throw new Error(data.error || data.message || 'Failed to send code.');
            }

            if (sentToEl) {
                sentToEl.textContent = formatPhone(currentPhone);
            }

            showStep(2);
        } catch (error) {
            showError('send', error.message || 'Something went wrong. Please try again.');
        } finally {
            setButtonLoading(sendBtn, false);
        }
    }

    async function handleVerifyCode(e) {
        e.preventDefault();

        if (isVerifying) {
            return;
        }

        clearError('check');

        const code = getOtpCode();
        if (code.length !== 6) {
            showError('check', 'Please enter the complete 6-digit code.');
            return;
        }

        isVerifying = true;
        setButtonLoading(verifyBtn, true);

        try {
            const response = await fetch(API_BASE + '/api/verify/check', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    contact: currentPhone,
                    email: currentEmail,
                    firstName: currentFirstName,
                    lastName: currentLastName,
                    code: code,
                    variantId: window.FQ_VARIANT_ID || 'gid://shopify/ProductVariant/52313945538888',
                    channel: 'sms',
                    likelyMuslim: identityFlaggedMuslim,
                    whatsappConsent: whatsappConsent ? whatsappConsent.checked : false
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Invalid verification code.');
            }

            showStep(3);
            clearResendTimer();

            setTimeout(function () {
                if (data.checkoutUrl) {
                    window.location.href = data.checkoutUrl;
                }
            }, 1500);
        } catch (error) {
            showError('check', error.message || 'Invalid code. Please try again.');
            otpInputs.forEach(function (input) {
                input.value = '';
            });
            if (otpInputs[0] && !isMobileViewport()) {
                otpInputs[0].focus();
            }
        } finally {
            isVerifying = false;
            setButtonLoading(verifyBtn, false);
        }
    }

    async function handleResendCode() {
        clearError('check');
        resendBtn.disabled = true;
        resendBtn.textContent = 'Sending...';

        try {
            const response = await fetch(API_BASE + '/api/verify/send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    contact: currentPhone,
                    channel: 'sms'
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to resend code.');
            }

            startResendTimer();

            otpInputs.forEach(function (input) {
                input.value = '';
            });

            if (otpInputs[0] && !isMobileViewport()) {
                otpInputs[0].focus();
            }
        } catch (error) {
            showError('check', error.message || 'Unable to resend code right now.');
        } finally {
            resendBtn.disabled = false;
            resendBtn.innerHTML = 'Did not receive it? <strong>Resend code</strong>';
        }
    }

    function startResendTimer() {
        clearResendTimer();

        resendCountdown = RESEND_COOLDOWN;

        if (resendBtn) resendBtn.hidden = true;
        if (resendTimerEl) resendTimerEl.hidden = false;

        updateResendTimerDisplay();

        resendTimer = setInterval(function () {
            resendCountdown -= 1;

            if (resendCountdown <= 0) {
                clearResendTimer();
                if (resendBtn) resendBtn.hidden = false;
                if (resendTimerEl) resendTimerEl.hidden = true;
            } else {
                updateResendTimerDisplay();
            }
        }, 1000);
    }

    function updateResendTimerDisplay() {
        if (!resendTimerEl) return;
        resendTimerEl.innerHTML = 'Resend code in <strong>' + resendCountdown + 's</strong>';
    }

    function clearResendTimer() {
        if (resendTimer) {
            clearInterval(resendTimer);
            resendTimer = null;
        }
    }

    function showError(type, message) {
        const el = getErrorElement(type);
        if (!el) return;

        el.textContent = message;
        el.hidden = false;
        el.setAttribute('aria-hidden', 'false');
    }

    function clearError(type) {
        const el = getErrorElement(type);
        if (!el) return;

        el.textContent = '';
        el.hidden = true;
        el.setAttribute('aria-hidden', 'true');
    }

    function getErrorElement(type) {
        if (type === 'identity') return identityError;
        if (type === 'send') return sendError;
        return checkError;
    }

    function setButtonLoading(btn, loading) {
        if (!btn) return;

        const textEl = btn.querySelector('.fq-verify-btn-text');
        const loadingEl = btn.querySelector('.fq-verify-btn-loading');

        if (btn.dataset) {
            btn.dataset.fqLoading = loading ? 'true' : 'false';
        }

        btn.setAttribute('aria-busy', loading ? 'true' : 'false');

        if (textEl) {
            textEl.hidden = loading;
        }

        if (loadingEl) {
            loadingEl.hidden = !loading;
        }

        if (loading) {
            btn.disabled = true;
        } else if (btn === sendBtn) {
            syncConfirmCheckboxesUi();
        } else {
            btn.disabled = false;
        }

        updatePopupBusyState();
    }

    function updatePopupBusyState() {
        if (!dialog) return;

        const isBusy = [identityBtn, sendBtn, verifyBtn].some(function (btn) {
            return btn && btn.dataset && btn.dataset.fqLoading === 'true';
        });

        dialog.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function formatPhone(phone) {
        return '**** **** ' + phone.slice(-4);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.FQVerify = {
        open: openPopup,
        close: closePopup
    };
})();
